/**
 * @generated SignedSource<<8d46129604e80280bbc31992589b51f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MemberRole = "OWNER" | "%future added value";
export type MemberStatusValue = "DELETED" | "INVITED" | "PENDING_INVITATION" | "REGISTERED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserInfoPopover_member$data = {
  readonly email: string;
  readonly genealogyPerson: {
    readonly id: string;
  } | null;
  readonly id: string;
  readonly name: string;
  readonly roles: ReadonlyArray<MemberRole>;
  readonly status: {
    readonly value?: MemberStatusValue;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member">;
  readonly " $fragmentType": "UserInfoPopover_member";
};
export type UserInfoPopover_member$key = {
  readonly " $data"?: UserInfoPopover_member$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserInfoPopover_member">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserInfoPopover_member",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roles",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserAvatar_member"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Genealogy__Person",
      "kind": "LinkedField",
      "name": "genealogyPerson",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "type": "MemberDeletedStatus",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Member",
  "abstractKey": null
};
})();

(node as any).hash = "e16039cccd0ef36899716c394fba5627";

export default node;
